module.exports = __webpack_public_path__ + "static/templates-list-72ad5caaa7c8fcd84544afef1dc68b2a.png";